import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import * as ExchangeActions from 'state/exchange';
import './ExchangeSelect.scss';

const id = 'exchange-select';

const markets = [
  { value: 'XOSL', label: 'Oslo Børs' },
  { value: 'XSTO', label: 'Nasdaq Stockholm' },
];

const ExchangeSelect = ({ selected, selectExchange, history }) => {
  return (
    <div className="ExchangeSelect">
      <label htmlFor={id}>Vis/handle på</label>
      <div className="select-wrapper">
        <select
          id={id}
          onChange={({ target: { value } }) => {
            selectExchange(value);
            history.push('/overview');
          }}
          value={selected}
        >
          {markets.map(({ value, label }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  selected: state.exchange.selected,
});

export default compose(
  withRouter,
  connect(mapStateToProps, ExchangeActions),
)(ExchangeSelect);
